import React from "react";
import "../styles/forms.css";
import {
  saveFormacion,
  getDataFrm,
  deleteFormacion,
  getDataDelFormacion,
  getPerfil,
} from "../requests/req_perfil";
import { Col, Button, FormGroup, UncontrolledTooltip } from "reactstrap";
import { notifica, show_ldr } from "../requests/utils";
import Swal from "sweetalert2";
import { getNivelesEstudio } from "../requests/CatalogosGenerales";
import { postInsertarFormacion } from "./../requests/PerfilCandidato";

function TryParseInt(str) {
  var retValue = 0;
  if (str !== null) {
    if (str.length > 0) {
      if (!isNaN(str)) {
        retValue = parseInt(str);
      }
    }
  }
  return retValue;
}
export default class FrmFormacion extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      datos: this.props.datos,
      edit: false,
      isVisible: false,
      isVisibleAdd: true,
      nivelesEstudio: [],
    };
    this.llenaForm = this.llenaForm.bind(this);
    this.generaDivs = this.generaDivs.bind(this);
    this.generaCombo = this.generaCombo.bind(this);
    this.agregareditar = this.agregareditar.bind(this);
    this.guardaFormacion = this.guardaFormacion.bind(this);
    this.editCloseForm = this.editCloseForm.bind(this);
    this.agregaAnios = this.agregaAnios.bind(this);
    this.validarCampos = this.validarCampos.bind(this);
    this.eliminarFormacion = this.eliminarFormacion.bind(this);
    this.limpiarControles = this.limpiarControles.bind(this);
    this.llenarLista = this.llenarLista.bind(this);
    this.onChaneFecha = this.onChaneFecha.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
    if (this._isMounted) {
      this.agregaAnios();
      if (localStorage.getItem("frmfcn") != null) {
        this.editCloseForm(localStorage.getItem("frmfcn"));
      }
    }
    getNivelesEstudio().then((res) => {
      this.setState({ nivelesEstudio: res });
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
    var json = getDataFrm(".frmfcn");
    if (
      (JSON.parse(json).CentroEducativo !== "" ||
        (JSON.parse(json).IdNivelEstudios !== "" &&
          JSON.parse(json).IdNivelEstudios !== "0") ||
        (JSON.parse(json).IdEstatusFormacion !== "" &&
          JSON.parse(json).IdEstatusFormacion !== "0") ||
        JSON.parse(json).anioMesInicio.split("-")[0] !== "null" ||
        JSON.parse(json).anioMesFin.split("-")[0] !== "null") &&
      this.state.edit
    )
      localStorage.setItem("frmfcn", json);
    else localStorage.removeItem("frmfcn");
  }
  componentWillReceiveProps() {
    this.agregaAnios();
    if (localStorage.getItem("frmfcn") != null) {
      this.editCloseForm(localStorage.getItem("frmfcn"));
    }
  }
  editCloseForm(data) {
    if (data != null) {
      var dv = document.getElementById("dv_FrmFrmcn"),
        btnSv = document.getElementById("img_sv_FR");
      if (btnSv) btnSv.classList.remove("Hide_All");
      dv.classList.remove("Hide_All");

      var Items = JSON.parse(data);
      var anioMesFinM = document.getElementById("anioMesFinM");
      var anioMesFinA = document.getElementById("anioMesFinA");
      var anioMesInicioA = document.getElementById("anioMesInicioA");
      var anioMesInicioM = document.getElementById("anioMesInicioM");
      var idEstatusFormacion = document.getElementById("idEstatusFormacion");
      var idNivelesEstudios = document.getElementById("idNivelesEstudios");
      var centroEducativo = document.getElementById("centroEducativo");
      anioMesFinM.value =
        Items.anioMesFin.split("-")[0] != null
          ? Items.anioMesFin.split("-")[0]
          : "";
      anioMesFinA.value =
        Items.anioMesFin.split("-")[1] != null
          ? Items.anioMesFin.split("-")[1]
          : "";
      anioMesInicioA.value =
        Items.anioMesInicio.split("-")[1] != null
          ? Items.anioMesInicio.split("-")[1]
          : "";
      anioMesInicioM.value =
        Items.anioMesInicio.split("-")[0] != null
          ? Items.anioMesInicio.split("-")[0]
          : "";
      idEstatusFormacion.value =
        Items.IdEstatusFormacion !== "0" ? Items.IdEstatusFormacion : "";
      idNivelesEstudios.value =
        Items.IdNivelEstudios !== "0" ? Items.IdNivelEstudios : "";
      centroEducativo.value =
        Items.CentroEducativo !== "" ? Items.CentroEducativo : "";
    }
  }
  agregaAnios() {
    var dv = document.getElementById("anioMesFinA");
    let newDate = new Date();
    let year = newDate.getFullYear();
    for (let i = 0; i <= 100; i++) {
      let option = document.createElement("option");
      option.text = year - i;
      option.value = year - i;
      dv.add(option);
    }
    let dv2 = document.getElementById("anioMesInicioA");
    for (let i = 0; i <= 100; i++) {
      let option = document.createElement("option");
      option.text = year - i;
      option.value = year - i;
      dv2.add(option);
    }
  }
  agregarNuevo(e) {
    this.setState({ edit: false, isVisibleAdd: false, isVisible: true });

    var idF = "0",
      dv = document.getElementById("dv_FrmFrmcn");
    dv.classList.remove("Hide_All");

    if (idF !== "0") {
      var fila = this.props.datos.filter(
        (f) => f.idFormacionCandidato === parseInt(idF, 10)
      )[0];
      this.llenaForm(fila);
    }
  }
  agregareditar(e) {
    this.setState({ edit: true, isVisibleAdd: false, isVisible: true });
    const { datos } = this.props;
    const elm = e.target,
      idF = elm.getAttribute("idformacion"),
      dv = document.getElementById("dv_FrmFrmcn");

    dv.classList.remove("Hide_All");

    if (idF === "0") return;
    const fila = datos.filter(
      (f) => f.idFormacionCandidato === parseInt(idF, 10)
    );
    if (fila) {
      this.llenaForm(fila[0]);
    }
  }

  llenaForm(fila) {
    for (let key in fila) {
      const inp = document.getElementsByName(key);
      if (!inp[0]) continue;
      if (inp[0].tagName !== "DIV") {
        inp[0].value = fila[key];
        continue;
      }

      const ipt = inp[0].querySelector("input");
      const sel = inp[0].querySelector("select");
      const val = fila[key].split("-");
      if (val === null) continue;
      if (sel !== null) {
        if (["anioMesFin", "anioMesInicio"].includes(key)) {
          document.getElementById(`${key}M`).value = val[0];
          document.getElementById(`${key}A`).value = val[1];
        } else {
          sel.value = val[0];
        }
      }
      if (ipt !== null) ipt.value = val[1];
    }
  }
  eliminarFormacion(e) {
    let resp = e.target;
    Swal.fire({
      title: "¿Estas seguro que deseas eliminar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        var elm = resp,
          idF = elm.getAttribute("idformacion");
        if (idF == null) return false;
        var item = getDataDelFormacion(parseInt(idF, 10));
        deleteFormacion(item, (x) => console.log(x));
        var dv2 = document.getElementById("dvFormacion" + parseInt(idF, 10));
        if (dv2 != null)
          for (var i = 0; i < this.state.datos.length; i++) {
            if (
              this.state.datos[i].idFormacionCandidato === parseInt(idF, 10)
            ) {
              this.state.datos.splice(i, 1);
            }
          }
        var btnrefresh = document.getElementById("btnrefresh");
        if (btnrefresh) btnrefresh.click();
        const { handleUpdate } = this.props;
        handleUpdate && handleUpdate();
      }
    });
  }
  generaDivs(datos) {
    const { edit } = this.state;
    if (!datos) return null;
    return datos.map((e, index) => {
      return (
        <div
          className="dv_Formacion"
          id={"dvFormacion" + e.idFormacionCandidato}
          key={index}
        >
          <div className="dv_Full_frmcn">
            <div className="dv_Full_frmcn_Lft">
              <label>{e.centroEducativo}</label>
            </div>
            <div className="dv_Full_frmcn_Rgt">
              <label>
                {(e.anioMesInicio.split("-")[0] !== "null"
                  ? e.anioMesInicio
                  : e.anioMesInicio.split("-")[1]) +
                  " a " +
                  (e.anioMesFin.split("-")[0] !== "null"
                    ? e.anioMesFin
                    : e.anioMesFin.split("-")[1])}
              </label>
              <img
                src={window.origin + "/images/icon_edit_1.png"}
                alt="Editar"
                id={"img_edit" + e.idFormacionCandidato}
                idformacion={e.idFormacionCandidato}
                onClick={(e) => this.agregareditar(e)}
              />
              <UncontrolledTooltip
                placement="top"
                target={"img_edit" + e.idFormacionCandidato}
              >
                Editar
              </UncontrolledTooltip>
              <img
                src={window.origin + "/images/icon_delete_1.png"}
                alt="Eliminar"
                id={"imgform_delete" + e.idFormacionCandidato}
                idformacion={e.idFormacionCandidato}
                onClick={(e) => this.eliminarFormacion(e)}
                className={edit ? "d-none" : ""}
              />
              <UncontrolledTooltip
                placement="top"
                target={"imgform_delete" + e.idFormacionCandidato}
              >
                Eliminar
              </UncontrolledTooltip>
            </div>
          </div>
          <label>{"Nivel de Estudios: " + e.nivelEstudios}</label>
          <br />
        </div>
      );
    });
  }
  generaCombo(datos) {
    if (datos !== null) {
      return datos.map((i, index) => {
        return (
          <option value={i.IdValor} key={index}>
            {i.Descripcion}
          </option>
        );
      });
    }
  }

  guardaFormacion(e) {
    if (!this.validarCampos()) return;
    const { handleUpdate } = this.props;
    if (this.state.edit === false) {
      let json = getDataFrm(".frmfcn");
      localStorage.removeItem("");
      let contador = 0;
      var parJ = JSON.parse(json);
      parJ.idFormacionCandidato = "";
      json = parJ;

      this.state.datos.map(function (obj) {
        if (
          obj.centroEducativo === parJ.CentroEducativo &&
          obj.idNivelesEstudios === parseInt(parJ.IdNivelEstudios)
        ) {
          return contador++;
        }
        return null;
      });

      if (contador === 0) {
        show_ldr(true);
        let parsedData = {
          IdCandidato: json.idCandidato,
          IdFormacionCandidato:
            json.idFormacionCandidato === "" ? 0 : json.idFormacionCandidato,
          CentroEducativo: json.CentroEducativo,
          IdEstatusFormacion: json.IdEstatusFormacion,
          IdNivelEstudios: json.IdNivelEstudios,
          AnioMesFin: json.anioMesFin,
          AnioMesInicio: json.anioMesInicio,
        };
        postInsertarFormacion(parsedData).then((res) => {
          handleUpdate && handleUpdate();
          show_ldr(false);
          getPerfil((v) => this.llenarLista(v.tabla6));
        });
      } else {
        notifica(
          "warning",
          "Ya se encuentra registrado esta formación",
          "Error"
        );
      }
    } else {
      saveFormacion(
        (s) => getPerfil((v) => this.llenarLista(v.tabla6)),
        this.state.edit,
        this.state.datos
      );

      handleUpdate && handleUpdate();
    }
  }

  llenarLista(datos) {
    this.setState({
      datos: datos,
    });
    if (datos != null) {
      var idNivelesEstudios = document.getElementById("idNivelesEstudios");
      var selected =
        idNivelesEstudios.options[idNivelesEstudios.selectedIndex].text;
      var json = JSON.parse(getDataFrm(".frmfcn"));
      var Item = {
        Especialidad: "",
        NivelEstudios: selected,
        anioMesFin: json.anioMesFin,
        anioMesInicio: json.anioMesInicio,
        centroEducativo: json.CentroEducativo,
        descripcionArea: "",
        idEspecialidad: 0,
        idEstatusFormacion: 0,
        idFormacionCandidato: parseInt(datos[0].idFormacionCandidato, 10),
        idNivelesEstudios: 0,
        idTipoFormacion: 0,
      };
      this.state.datos.push(Item);
    }

    this.setState({ edit: false, isVisible: false, isVisibleAdd: true });
    var dv = document.getElementById("dv_FrmFrmcn");
    dv.classList.add("Hide_All");
    var btnrefresh = document.getElementById("btnrefresh");
    if (btnrefresh) {
      btnrefresh.click();
    }
    this.limpiarControles();
  }
  limpiarControles() {
    var centroEducativo = document.getElementById("centroEducativo");
    var idNivelesEstudios = document.getElementById("idNivelesEstudios");
    var idEstatusFormacion = document.getElementById("idEstatusFormacion");
    var anioMesFinM = document.getElementById("anioMesFinM");
    var anioMesFinA = document.getElementById("anioMesFinA");
    var anioMesInicioA = document.getElementById("anioMesInicioA");
    var anioMesInicioM = document.getElementById("anioMesInicioM");
    if (centroEducativo) centroEducativo.value = "";
    if (idNivelesEstudios) idNivelesEstudios.value = "0";
    if (idEstatusFormacion) idEstatusFormacion.value = "0";
    if (anioMesFinM) anioMesFinM.value = "null";
    if (anioMesFinA) anioMesFinA.value = "2019";
    if (anioMesInicioA) anioMesInicioA.value = "2019";
    if (anioMesInicioM) anioMesInicioM.value = "null";
  }
  validarCampos() {
    var i = 0;
    var centroEducativo = document.getElementById("centroEducativo");
    var idNivelesEstudios = document.getElementById("idNivelesEstudios");
    var idEstatusFormacion = document.getElementById("idEstatusFormacion");
    let fecha = this.onChaneFecha();
    if (fecha === 2) {
      notifica("warning", "Las Fechas no pueden ir vacias", "Alerta!");
      i++;
    } else if (fecha === 1) {
      i++;
    }
    if (centroEducativo.value === "" || centroEducativo.value == null) {
      notifica("warning", "Debe indicar un centro educativo", "Alerta!");
      i++;
    }
    if (idNivelesEstudios.value === "0" || idNivelesEstudios.value == null) {
      notifica("warning", "Debe indicar el Nivel académico", "Alerta!");
      i++;
    }
    if (idEstatusFormacion.value === "0" || idEstatusFormacion.value == null) {
      notifica("warning", "Debe indicar el Estatus", "Alerta!");
      i++;
    }

    if (i > 0) return false;
    else return true;
  }
  onChaneFecha(e) {
    let mesInicio = document.getElementById("anioMesInicioM");
    let anioInicio = document.getElementById("anioMesInicioA");
    let mesFin = document.getElementById("anioMesFinM");
    let anioFin = document.getElementById("anioMesFinA");
    if (
      mesInicio.value === "null" ||
      anioInicio.value === "null" ||
      mesFin.value === "null" ||
      anioFin.value === "null"
    ) {
      return 2;
    }
    let fechaInicio = new Date(
      parseInt(anioInicio.value),
      parseInt(mesInicio.value)
    );
    let fechaFin = new Date(parseInt(anioFin.value), parseInt(mesFin.value));
    if (fechaInicio >= fechaFin) {
      notifica("warning", "Debe ingresar fechas validas", "Alerta!");
      return 1;
    }
    return 0;
  }

  render() {
    const { isVisible, isVisibleAdd } = this.state;
    return (
      <div className="APL_Frm_dv">
        <FormGroup className="dv_Form_New_Edit Hide_All" id="dv_FrmFrmcn" row>
          <Col sm={2} md={2} lg={2}>
            {" "}
            <label className="lbl_md">
              Centro Educativo:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              id="inp_IdFrmcn"
              className="frm frmfcn"
              name="idFormacionCandidato"
              datsvfrm="idFormacionCandidato"
              type="hidden"
            />
            <input
              type="text"
              className="frm frmfcn"
              datsvfrm="CentroEducativo"
              name="centroEducativo"
              id="centroEducativo"
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            {" "}
            <label className="lbl_md">
              Nivel académico:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              className="frm frmfcn"
              datsvfrm="IdNivelEstudios"
              name="idNivelesEstudios"
              id="idNivelesEstudios"
            >
              <option value="0">Selecciona...</option>
              {this.state.nivelesEstudio.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={2} md={2} lg={2}>
            {" "}
            <label className="lbl_md">
              Estatus:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              className="frm frmfcn"
              datsvfrm="IdEstatusFormacion"
              name="idEstatusFormacion"
              id="idEstatusFormacion"
            >
              <option value="0">Selecciona...</option>
              <option value="1">En curso</option>
              <option value="2">Finalizado</option>
              <option value="3">Trunco</option>
            </select>
          </Col>
          <Col sm={2} md={2} lg={2}>
            {" "}
          </Col>
          <Col sm={4} md={4} lg={4}></Col>
          <Col sm={2} md={2} lg={2}>
            {" "}
            <label className="lbl_md">Fecha Inicio:</label>{" "}
          </Col>
          <Col sm={4} md={4} lg={4} name="anioMesInicio">
            <select
              className="frm frm_sml frmfcn"
              onChange={(e) => this.onChaneFecha(e)}
              datsvfrm="anioMesInicioM"
              id="anioMesInicioM"
            >
              <option value="null">Selecciona...</option>
              <option value="01">Enero</option>
              <option value="02">Febrero</option>
              <option value="03">Marzo</option>
              <option value="04">Abril</option>
              <option value="05">Mayo</option>
              <option value="06">Junio</option>
              <option value="07">Julio</option>
              <option value="08">Agosto</option>
              <option value="09">Septiembre</option>
              <option value="10">Octubre</option>
              <option value="11">Noviembre</option>
              <option value="12">Diciembre</option>
            </select>
            <select
              className="frm frm_sml frmfcn"
              onChange={(e) => this.onChaneFecha(e)}
              datsvfrm="anioMesInicioA"
              id="anioMesInicioA"
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            {" "}
            <label className="lbl_md">Fecha Fin:</label>{" "}
          </Col>
          <Col sm={4} md={4} lg={4} name="anioMesFin">
            <select
              className="frm frm_sml frmfcn"
              datsvfrm="anioMesFinM"
              onChange={(e) => this.onChaneFecha(e)}
              id="anioMesFinM"
            >
              <option value="null">Selecciona...</option>
              <option value="01">Enero</option>
              <option value="02">Febrero</option>
              <option value="03">Marzo</option>
              <option value="04">Abril</option>
              <option value="05">Mayo</option>
              <option value="06">Junio</option>
              <option value="07">Julio</option>
              <option value="08">Agosto</option>
              <option value="09">Septiembre</option>
              <option value="10">Octubre</option>
              <option value="11">Noviembre</option>
              <option value="12">Diciembre</option>
            </select>
            <select
              onChange={(e) => this.onChaneFecha(e)}
              className="frm frm_sml frmfcn"
              datsvfrm="anioMesFinA"
              id="anioMesFinA"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={9} md={9} lg={9}></Col>
          <Col sm={3} md={3} lg={3}>
            {isVisibleAdd ? (
              <Button
                outline
                color="success"
                className="btn_exp_add"
                id="btn_frm_add"
                idformacion={0}
                onClick={(e) => this.agregarNuevo(e)}
              >
                <img
                  src={window.origin + "/images/icon_add_2.png"}
                  className="img_edit"
                  alt="Agregar"
                />
                Agregar Formación
              </Button>
            ) : null}
            {isVisible ? (
              <Button
                outline
                color="info"
                className="btn_exp_add "
                alt="Guardar"
                id="img_sv_FR"
                idformacion={0}
                onClick={(e) => this.guardaFormacion(e)}
              >
                <img
                  src={window.origin + "/images/icon_save_2.png"}
                  className="img_edit "
                  alt=""
                />
                Guardar Cambios
              </Button>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12} md={12} lg={12} id="dv_frmcn">
            {this.generaDivs(this.state.datos)}
          </Col>
        </FormGroup>
      </div>
    );
  }
}
